<script>
export default {
    name: "CatalogFilterLoading"
}
</script>

<template>
    <div class="space-y-4 divide-y divide-gray-200">
        <div class="flex items-center justify-between mb-4">
            <div class="h-6 bg-gray-300 rounded w-24 animate-pulse"></div>
            <div class="h-6 bg-gray-300 rounded w-24 animate-pulse"></div>
        </div>
        <div v-for="i in 5" class="pt-4">
            <div class="flex items-center justify-between mb-4">
                <div class="h-5 bg-gray-300 rounded w-24 animate-pulse"></div>
                <div class="h-4 w-4 bg-gray-300 rounded-full animate-pulse"></div>
            </div>
            <div class="space-y-3 max-h-64 overflow-y-auto pr-2">
                <div v-for="n in 8" :key="'color-'+n" class="flex items-center gap-3">
                    <div class="h-4 w-4 bg-gray-300 rounded animate-pulse"></div>
                    <div class="h-4 bg-gray-300 rounded w-32 animate-pulse"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
